import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  DepositCancelReasonBean,
  DepositCancelReasonSearchCriteria,
  RestDepositCancelReasonListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class DepositCancelReasonListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }

  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  deleteOnClick = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteOnClick(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };
  editDepositCancelReason = (e, rowdata) => {
    if (e.detail === 1) this.props.editDepositCancelReason(rowdata);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let depositCancelReason_list = this.props.depositCancelReason_list;
    let depositCancelReasonData = this.props.depositCancelReasonData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel id="searchBarLabel">Deposit Cancel Reason</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                type="text"
                name="code"
                onChange={this.onChange}
                value={depositCancelReasonData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              {depositCancelReason_list.map((Info, index) => (
                <tr key={index}>
                  <td className="td_attribute_width">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.editDepositCancelReason(e, Info.code, Info)
                      }
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                  <td className="text-right">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.deleteOnClick(e, Info.code, Info)}
                    >
                      {<DeleteIcon />}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {depositCancelReason_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class DepositCancelReasonEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
    this.state = {
      showHide: this.props.showHide,
      depositCancelReasonData: this.props.depositCancelReasonData,
    };
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  render() {
    let depositCancelReasonData = this.props.depositCancelReasonData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={depositCancelReasonData.companyCode}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter DepositCancelReasonCode"
              onChange={this.onChange}
              value={depositCancelReasonData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={depositCancelReasonData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={depositCancelReasonData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class DepositCancelReasonList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      depositCancelReason_list: [],
      response: {},
      pageTitle: "Deposit Cancel Reason",
      depositCancelReasonData: new DepositCancelReasonBean(),
      pageList: new PageListBean(),
      criteria: new DepositCancelReasonSearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isDepositCancelReasonListFormOpen: true,
      isDepositCancelReasonEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let depositCancelReasonData = new DepositCancelReasonBean();
    depositCancelReasonData.companyCode = this.companyCode;
    this.setState({ depositCancelReasonData: depositCancelReasonData });
    this.loadPage(1);
    this.cleardata();
  }

  moduleCaption = "Deposit Cancel Reason";

  cleardata = () => {
    let depositCancelReasonData = new DepositCancelReasonBean();
    depositCancelReasonData.companyCode = this.companyCode;
    this.setState({ depositCancelReasonData: depositCancelReasonData });
  };
  saveDepositCancelReasonResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeDepositCancelReasonEntryForm();
  };

  saveDepositCancelReason = () => {
    let input = this.state.depositCancelReasonData;
    if (input.isFetched == true) {
      if (
        SecurityAccessManager.DepositCancelReasonMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateDepositCancelReason(
          input,
          this.saveDepositCancelReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.DepositCancelReasonMaintenanceEdit_IsAccessible()
      ) {
        MasterService.createDepositCancelReason(
          input,
          this.saveDepositCancelReasonResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editDepositCancelReasonResponse = (response) => {
    if (response.data != null) {
      if (response.data.depositCancelReason != null) {
        let depositCancelReason = response.data.depositCancelReason;
        this.setState({
          depositCancelReasonData: depositCancelReason,
        });
        this.disable();
      }
      this.openDepositCancelReasonEntryForm();
    }
  };

  editDepositCancelReason = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (
      SecurityAccessManager.DepositCancelReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.readDepositCancelReason(
        readrestInput,
        this.editDepositCancelReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let depositCancelReasonData = this.state.depositCancelReasonData;
    depositCancelReasonData[e.target.name] = e.target.value;
    this.setState({
      depositCancelReasonData: depositCancelReasonData,
    });
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  deleteOnClick = (val, rowData) => {
    //
  };
  opentypeforms = () => {
    let depositCancelReasonData = this.state.depositCancelReasonData;
    this.editDepositCancelReason(depositCancelReasonData.code);
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  save = () => {
    this.saveDepositCancelReason();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeDepositCancelReasonEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openDepositCancelReasonEntryForm = () => {
    this.setState({
      isDepositCancelReasonListFormOpen: false,
      isDepositCancelReasonEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeDepositCancelReasonEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isDepositCancelReasonListFormOpen: true,
      isDepositCancelReasonEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadDepositCancelReasonResponse = (response) => {
    if (
      response.data != null &&
      response.data.depositCancelReasonPageList != null
    ) {
      let depositCancelReason = new Array();
      if (
        !isEmptyArray(
          response.data.depositCancelReasonPageList.depositCancelReason
        )
      ) {
        depositCancelReason =
          response.data.depositCancelReasonPageList.depositCancelReason;
        depositCancelReason.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount =
        response.data.depositCancelReasonPageList.totalCount;
      pageList.currentPage =
        response.data.depositCancelReasonPageList.currentPage;
      pageList.pageSize = response.data.depositCancelReasonPageList.pageSize;

      this.setState({
        depositCancelReason_list: depositCancelReason,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new DepositCancelReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadDepositCancelReasonPage(pageInput, criteria);
  };
  loadDepositCancelReasonPage = (pageList, criteria) => {
    let requestInput = new RestDepositCancelReasonListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.DepositCancelReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.getDepositCancelReasonPageList(
        requestInput,
        this.loadDepositCancelReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.depositCancelReason_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ depositCancelReason_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isDepositCancelReasonListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isDepositCancelReasonListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isDepositCancelReasonListFormOpen && (
          <DepositCancelReasonListForm
            {...this.state}
            onChange={this.onChange}
            deleteOnClick={this.deleteOnClick}
            enterKeyEventHandler={this.enterKeyEventHandler}
            opentypeforms={this.opentypeforms}
            editDepositCancelReason={this.editDepositCancelReason}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isDepositCancelReasonEntryFormOpen && (
          <DepositCancelReasonEntryForm
            {...this.state}
            onChange={this.onChange}
          />
        )}
      </div>
    );
  }
}

function DepositCancelReasonAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <DepositCancelReasonList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default DepositCancelReasonAttributeModule;
